<div class="h-[19rem] w-full rounded-xl bg-white px-8 py-4 shadow-xl">
  <h3 class="border-b border-gray-300 pb-2 text-2xl font-bold text-black">{{ productTitle() }}</h3>
  <p class="mb-4 pt-2 text-gray-400">{{ mfgCompany() }}</p>
  <div class="flex items-start justify-start gap-24">
    <div>
      <p class="text-gray-500" i18n="@@pharmacyPrice">pharmacy price</p>
      <div class="flex items-center gap-5">
        <p>
          {{ pharmacyPrice() }}
          <span i18n="@@EGP">EGP</span>
        </p>
      </div>
    </div>
    <div>
      <p class="text-gray-500" i18n="@@peoplePrice">people price</p>
      <p>
        {{ peoplePrice() }}
        <span i18n="@@EGP">EGP</span>
      </p>
    </div>
  </div>

  <div class="mt-4">
    <p i18n="@@stock.field.quantity">Quantity</p>
    <div class="flex items-center gap-4">
      <div class="flex w-fit items-center gap-6 rounded-lg border p-1">
        <button class="bg-primary-20 cursor-pointer rounded-lg px-3 py-1 text-xl" (click)="onDecreaseItem()">-</button>
        <span class="text-xl">{{ quantity() }}</span>
        <button class="bg-primary-20 cursor-pointer rounded-lg px-3 py-1 text-xl" (click)="onIncreaseItem()">+</button>
      </div>

      <button
        type="button"
        (click)="onAddToCart()"
        [disabled]="isAddingToCart() || isPharmacySuspended() || isLimitReached()"
        class="icon flex cursor-pointer items-center justify-center rounded-lg border border-gray-200 p-1 disabled:cursor-not-allowed disabled:opacity-50">
        @if (isAddingToCart()) {
          <app-loading />
        } @else if (addedToCart()) {
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M5 13l4 4L19 7" />
          </svg>
        } @else {
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 56 56">
            <path
              fill="currentColor"
              d="M20.008 39.649H47.36c.913 0 1.71-.75 1.71-1.758s-.797-1.758-1.71-1.758H20.406c-1.336 0-2.156-.938-2.367-2.367l-.375-2.461h29.742c3.422 0 5.18-2.11 5.672-5.461l1.875-12.399a7 7 0 0 0 .094-.89c0-1.125-.844-1.899-2.133-1.899H14.641l-.446-2.976c-.234-1.805-.89-2.72-3.28-2.72H2.687c-.937 0-1.734.822-1.734 1.76c0 .96.797 1.781 1.735 1.781h7.921l3.75 25.734c.493 3.328 2.25 5.414 5.649 5.414m31.054-25.454L49.4 25.422c-.188 1.453-.961 2.344-2.344 2.344l-29.906.023l-1.993-13.594ZM21.86 51.04a3.766 3.766 0 0 0 3.797-3.797a3.78 3.78 0 0 0-3.797-3.797c-2.132 0-3.82 1.688-3.82 3.797c0 2.133 1.688 3.797 3.82 3.797m21.914 0c2.133 0 3.82-1.664 3.82-3.797c0-2.11-1.687-3.797-3.82-3.797c-2.109 0-3.82 1.688-3.82 3.797c0 2.133 1.711 3.797 3.82 3.797" />
          </svg>
        }
      </button>

      <span class="icon cursor-pointer rounded-lg border border-gray-200 p-1">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M20.16 5A6.29 6.29 0 0 0 12 4.36a6.27 6.27 0 0 0-8.16 9.48l6.21 6.22a2.78 2.78 0 0 0 3.9 0l6.21-6.22a6.27 6.27 0 0 0 0-8.84m-1.41 7.46l-6.21 6.21a.76.76 0 0 1-1.08 0l-6.21-6.24a4.29 4.29 0 0 1 0-6a4.27 4.27 0 0 1 6 0a1 1 0 0 0 1.42 0a4.27 4.27 0 0 1 6 0a4.29 4.29 0 0 1 .08 6Z" />
        </svg>
      </span>
    </div>

    @if (addToCartError()) {
      <p class="mt-2 text-xs font-light text-red-500">{{ addToCartError() }}</p>
    }
  </div>
</div>
